import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import CustomButton from "@/shared/components/kit/button";
import React from "react";

interface FinishStepProps {
    onSuccess: () => void;
}

const Finish = ({ onSuccess }: FinishStepProps) => {
    return (
        <Grid container sx={{width: "100%",justifyContent: "space-between",minHeight: "486px",marginBottom: "30px",padding: "10px 30px",alignItems: "center",display: "flex",}}>
            <Grid size={12}>
                <StackKit sx={{width: "100%", height: "100%",}}>
                    <TypoGraphyKit variant="body1" sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        اطلاعات شما در حال پردازش میباشد نتیجه از طریق پیامک به شما اطلاع رسانی خواهد شد.
                    </TypoGraphyKit>
                    <TypoGraphyKit variant="body1" sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        با تشکر از شکیبایی شما
                    </TypoGraphyKit>
                </StackKit>
                <CustomButton className={'mt-4'} onClick={onSuccess}>
                    بازگشت
                </CustomButton>
            </Grid>
        </Grid>
    );
};

export default Finish;